import { render, staticRenderFns } from "./CarbonEmissionsIcon.vue?vue&type=template&id=000c9d98&scoped=true&"
import script from "./CarbonEmissionsIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CarbonEmissionsIcon.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CarbonEmissionsIcon.vue?vue&type=style&index=0&id=000c9d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c9d98",
  null
  
)

export default component.exports